import { styled } from "styled-components";

import { UIActionButton } from "common/components";

export const CompletedDownloadContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 1rem;
  padding: 10px;
`;

export const CloseButton = styled(UIActionButton)`
  height: 20px;
  width: 20px;

  > div {
    background: none;
    color: ${({ theme }) => theme.colors.textFade};

    &:hover {
      background: none;
      color: ${({ theme }) => theme.colors.textBright};
    }
  }
`;
